import { Box, Flex } from '@chakra-ui/react';
import Select, { components } from 'react-select';

import { Condition, Iteration } from 'Component/others';
import { TextBold, TextRegular, TextSemiBold } from 'UiKit/typography';
import SkeletonComponent from 'UiKit/skeleton';
import { ChevronDownIcon } from 'Asset/icon';

import styles from './styles.module.css';
import './styles.css';

const InputRuleset = ({ label, titleClassName, isRequired, onChange, options, value, placeholder, minHeight = '34px', isLoading }) => {
  const Control = (props) => {
    const { children } = props;
    return (
      <components.Control className={`input-ruleset__control`} {...props}>
        {children}
      </components.Control>
    );
  };

  const Option = ({ children, ...props }) => {
    const { data, isDisabled, isSelected } = props;
    return (
      <components.Option
        className={`${styles['input-ruleset__option']} ${isDisabled && styles['input-ruleset__option--disabled']} ${
          isSelected && styles['input-ruleset__option--selected']
        }`}
        {...props}
      >
        <Box className={styles['input-ruleset__section--text-name']}>
          <Iteration
            items={data?.accountLivestreams}
            render={(account, index) => {
              return (
                <>
                  <TextBold className={styles['input-ruleset__text--name']}>{`${account.name} `}</TextBold>
                  <TextRegular className={styles['input-ruleset__text--platform']}>
                    {account.platform}
                    <Condition statement={index + 1 < data?.accountLivestreams.length}>{', '}</Condition>
                  </TextRegular>
                </>
              );
            }}
          />
        </Box>
        <TextRegular className={styles['input-ruleset__text--type']}>{data?.type}</TextRegular>
      </components.Option>
    );
  };

  const Menu = ({ children, ...props }) => {
    return (
      <components.Menu {...props} className={styles['input-ruleset__menu']}>
        {children}
      </components.Menu>
    );
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator className="dropdown" {...props}>
        <ChevronDownIcon color="var(--color-semantic-text)" size="16px" cursor="pointer" />
      </components.DropdownIndicator>
    );
  };

  const SingleValue = (props) => {
    const { children, hasValue, getValue } = props;
    const data = getValue()[0];
    return (
      <components.SingleValue {...props} className={styles['input-ruleset__single-value']}>
        <Condition statement={hasValue} fallback={children}>
          <Flex>
            <Iteration
              items={data?.accountLivestreams}
              render={(account, index) => {
                return (
                  <>
                    <TextBold className={styles['input-ruleset__text--name']}>{account.name} </TextBold>
                    <TextRegular className={styles['input-ruleset__text--platform']}>
                      {account.platform}
                      <Condition statement={index + 1 < data?.accountLivestreams.length}>{', '}</Condition>
                    </TextRegular>
                  </>
                );
              }}
            />
          </Flex>
          <TextRegular className={styles['input-ruleset__text--type']}>{data?.type}</TextRegular>
        </Condition>
      </components.SingleValue>
    );
  };

  return (
    <Box className={`${styles['input-ruleset__container']} ${!value ? 'input-ruleset__container--empty' : 'input-ruleset__container--has-value'}`}>
      <Condition statement={label}>
        <TextSemiBold className={`${titleClassName} ${styles['text__title']}`}>
          {label}{' '}
          <Condition statement={isRequired}>
            <span>*</span>
          </Condition>
        </TextSemiBold>
      </Condition>
      <Condition statement={!isLoading} fallback={<SkeletonComponent height="35px" width="100%" data-testid="skeleton" />}>
        <Box className={styles['input-ruleset__select']} bg={value ? 'var(--color-semantic-white)' : 'var(--color-semantic-background)'}>
          <Select
            options={options}
            components={{
              Control,
              Option,
              Menu,
              DropdownIndicator,
              SingleValue,
              IndicatorSeparator: null,
            }}
            onChange={onChange}
            value={value}
            placeholder={placeholder}
            styles={{
              control: (baseStyles) => ({ ...baseStyles, minHeight, fontSize: 'var(--font-body2)' }),
              option: (baseStyles) => ({ ...baseStyles, fontSize: 'var(--font-body2)' }),
            }}
          />
        </Box>
      </Condition>
    </Box>
  );
};

export default InputRuleset;
